import { EditorContentService } from './editorcontent.service';
import { Injectable } from '@angular/core';


//#########################################################################
//
// This service is used to keep track of the last session. We use it to 
// store and retrieve the following data from local storage
//      - speed range preference
//      - previously written editor content
//      - autosave settings
//
//#########################################################################

@Injectable()
export class SessionStorageService {

  private automaticSaving = true;
  private DEFAULT_SPEED = "10";
  private DEFAULT_EDITORCONTENT = "";

  constructor(private editorContentService: EditorContentService) {}

  //store user preferences of speed if autosave is on
  public storeSpeed(){
    if (typeof(Storage) !== "undefined" && this.automaticSaving) {
      //store speed preferences in sessionstorage for next session
      sessionStorage.setItem("speedRange", (<HTMLInputElement>document.getElementById('speedRange')).value);
    }else{
      //if not restoring sessions: use speed 10 (maximum) on startup
      sessionStorage.setItem("speedRange", this.DEFAULT_SPEED);
    }
  }

  //retrieve user preferences for speed range
  public retrieveSpeed(){
    let speed = sessionStorage.getItem('speedRange');
    if(speed != undefined){
      (<HTMLInputElement>document.getElementById('speedRange')).value = sessionStorage.getItem('speedRange');
    }
  }

  //store editor contetn for next session if autosave is on
  public storeEditorContent(text:string){
    if (typeof(Storage) !== "undefined" && this.automaticSaving) {
      //store editor in sessionstorage for next session
      sessionStorage.setItem("editorText", text);//AppComponent.editor.getValue());
    }else{
      //if not automatically saving: prepare empty string to be restored by next user
      sessionStorage.setItem("editorText", this.DEFAULT_EDITORCONTENT);
    }
  }

  // retrieve editor content from previous session
  public retrieveEditorContent(){
    let text = sessionStorage.getItem('editorText');
    if(text != undefined){
      this.editorContentService.setTextOfCurrentEditorProgrammatically(text);
    }
    
  }

  //invert autosave prefs, used when menu item click in headerComponent
  public invertAutomaticSaving(text: string):boolean{
      this.automaticSaving = !this.automaticSaving;

      //store it to local storage for next session
      this.storeEditorContent(text);
      this.storeSpeed();

      return this.automaticSaving;
  }

  //getter for autosave setting
  public getAutomaticSavingStatus():boolean{
    return this.automaticSaving;
  }

  //setter for autosave setting
  public setAutomaticSavingStatus(value: boolean){
    this.automaticSaving = value;
  }
  
}




// WEBPACK FOOTER //
// ./src/app/services/sessionstorage.service.ts